import { render, staticRenderFns } from "./SelfServiceOpenLeaves.vue?vue&type=template&id=88ea3cca"
import script from "./SelfServiceOpenLeaves.vue?vue&type=script&lang=js"
export * from "./SelfServiceOpenLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports